var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "folder-24px_1_",
    "data-name": "folder-24px (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4125",
    "data-name": "Path 4125",
    className: "cls-1",
    d: "M0,0H18V18H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4126",
    "data-name": "Path 4126",
    d: "M8,4H3.5A1.5,1.5,0,0,0,2.007,5.5L2,14.5A1.5,1.5,0,0,0,3.5,16h12A1.5,1.5,0,0,0,17,14.5V7a1.5,1.5,0,0,0-1.5-1.5h-6Z",
    transform: "translate(-0.5 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCurrent);
export default __webpack_public_path__ + "static/media/status-current.7bda117adb71b6f4ffd6f43ad135784e.svg";
export { ForwardRef as ReactComponent };